module.exports = __webpack_public_path__ + "img/Corporate.2e02d1d8.png";